export const childrenPaths = []

export default [
  {
    path: "/library",
    name: "Library",
    meta: {
      title: "Library",
      icon: "bhi-book-open",
      requiresAuth: true
    },
    component: () => import("@/views/Library.vue")
  },
]